var ButtonPushBounceIdleBubbleAnim = require("clover/panel/component/common/uiButtonAnims/PushBounceIdleBubbleAnim")
var UIProgressTimer = require("clover/panel/component/common/UIProgressTimer")

var FriendPvpActivityStandingPanel = xClass("FriendPvpActivityStandingPanel", BasePanel, function () {
    return cc.CSLoader.createNode("cocos/panel_standings_panel_standings.csb")
})

FriendPvpActivityStandingPanel.show = function (logic, onCloseCb, refreshScoreCb) {
    var panel = FriendPvpActivityStandingPanel.create(logic, onCloseCb, refreshScoreCb);
    return panel;
}

FriendPvpActivityStandingPanel.prototype.ctor = function (logic, onCloseCb, refreshScoreCb) {
    var self = this;
    self.refreshScoreCb = refreshScoreCb;

    BasePanel.prototype.ctor.call(self);
    self.logic = logic;
    self.initUI();

    self.isBusy = true;
    var getList = function(){
        var onSuccess = function(evt){
            self.isBusy = false;
            self.showList(evt.data);
        }
        var onFail = function(evt){
            self.isBusy = false;
            cc.error(evt);
        }
        var http = PvpReportListHttp.new();
        http.addEventListener(Events.kComplete, onSuccess);
        http.addEventListener(Events.kError, onFail);
        http.addEventListener(Events.kCancel, onFail);
        http.load();
    }
    self.popup(getList);
}

FriendPvpActivityStandingPanel.prototype.initUI = function () {
    var self = this;
    self.getChildByName("txt").y -= 8;
    self.getChildByName("num").y -= 8;
    
    self.getBtn = self.getChildByName("btn_get");
    self.getBtn.getChildByName("label").x = -50;
    self.getBtn.getChildByName("label").setString(getText("pvp.battle.reportbutton02"));

    quickBuildUIBUtton(self.getBtn, () => {
        if (self.isBusy){
            return;
        }
        self.isBusy = true;
        if (self.scrollView){
            self.scrollView.removeFromParent();
            self.scrollView = null;
        }
        if (self.canGain || self.hasNotRead){
            DCAssist.userTrack("PVP", "click_onebtn_reward", {"abtest":"new"});
            var onSuccess = function(evt){
                self.isBusy = false;
                self.newScore = evt.data.totalScore;
                self.newAdTicket = evt.data.adTicketCount;
                self.refreshScoreCb(self.newScore, self.newAdTicket);
                if (self.canGain){
                    self.showRewards(evt.data.rewards);
                }
                // 领取完直接关闭
                self.onClose();
            }
            var onFail = function(evt){
                self.isBusy = false;
                cc.error(evt);
            }
            //--------------------------------------------------------------
            // if (__DEBUG){ 
            //     self.logic.pvpManager.gainReportRewardDEBUG(onSuccess);
            //     return;
            // }
            //--------------------------------------------------------------
            var http = GainReportRewardHttp.new();
            http.addEventListener(Events.kComplete, onSuccess);
            http.addEventListener(Events.kError, onFail);
            http.addEventListener(Events.kCancel, onFail);
            http.load(0);
        }else{
            self.isBusy = false;
            self.refreshScoreCb();
            self.onClose();
        }
    })
}

FriendPvpActivityStandingPanel.prototype.showList = function(data){
    var self = this;

    
    if (data[0] == null){
        data.list.splice(0, 1);
    }

    self.reportList = data;

    if (self.reportList.list.length <= 0){
        var label = cc.LabelTTF.create(getText("pvp.battlereport.none"), null, 25);
        self.addChild(label);
        label.setColor(cc.c4b(223, 122, 79, 255));
        label.setPosition(250, -280);
        self.getBtn.getChildByName("label").x = -50;
        self.getBtn.getChildByName("label").setString(getText("pvp.battle.reportbutton02"));
        quickBuildUIBUtton(self.getBtn, () => {
            self.isBusy = false;
            self.refreshScoreCb(0, 0);
            self.onClose();
        });
        return;
    }

    self.canGain = false;
    self.hasNotRead = false;
    var startTime = self.logic.pvpManager.activityInfo.startTime;
    var endTime = self.logic.pvpManager.activityInfo.endTime;
    for(var i = 0; i < self.reportList.list.length; i++){
        if (self.reportList.list[i].isGain == 0){
            self.hasNotRead = true;
            var time = self.reportList.list[i].timestamp;
            var isInActivityTime = false;
            if (time > startTime && time < endTime){
                isInActivityTime = true;
            }
            if (isInActivityTime){
                if (self.reportList.list[i].score != 0){
                    self.canGain = true;
                }
                var rewards = self.reportList.list[i].rewards;
                for(var j = 0; j < rewards.length; j++){
                    if (rewards[j]){
                        if (rewards[j].itemId && rewards[j].num){
                            self.canGain = true;
                        }
                    }
                }
            }
        }
    }
    
    self.getBtn = self.getChildByName("btn_get");
    if (self.canGain){
        self.getBtn.getChildByName("label").x = -85;
        self.getBtn.getChildByName("label").setString(getText("pvp.battle.reportbutton01"));
    }else{
        self.getBtn.getChildByName("label").x = -50;
        self.getBtn.getChildByName("label").setString(getText("pvp.battle.reportbutton02"));
    }

    
    var listLength = self.reportList.list.length;
    var listLength2 = listLength < 3 ? 3 : listLength;
    var innerHeight = (170) * listLength2;
    if (listLength2 <= 3){
        innerHeight = 505;
    }
    var size = cc.size(450, 450);
    var pos = cc.p(244, -270);
    var anchor = cc.p(0.5, 0.5);
    var listView = require("activity/PvpActivity/ListView");
    var scrollView = listView.create(listLength2, size, cc.size(430, innerHeight));
    scrollView.setDirection(ccui.ScrollViewDir.vertical);
    scrollView.setPosition(pos);
    scrollView.setAnchorPoint(anchor);
    scrollView.setItemOffset(20, 10);
    scrollView.setRefreshItemContentFunc(handler(self, self.refreshItemContent));
    self.addChild(scrollView);
    self.scrollView = scrollView;

    
    self.schedulerId = cc.director.getScheduler().scheduleScriptFunc(handler(self, self.addItem), 1/60, false);
    self.addItemIdx = 0;
}

FriendPvpActivityStandingPanel.prototype.addItem = function () {
    cc.log("addItem");
    var self = this;
    if (self.isClosed){
        cc.director.getScheduler().unscheduleScriptEntry(self.schedulerId);
    }
    if (self.addItemIdx < 4){
        if (!self.scrollView){
            return;
        }
        var scrollView = self.scrollView;
        var item = cc.CSLoader.createNode("cocos/panel_standings_info1.csb");
        // item.setAnchorPoint(cc.p(0, 1));
        item.idx = self.addItemIdx;
        scrollView.addItem(item, self.addItemIdx);
        item.y -= 5;
        item.x -= 5;

        var name = item.getChildByName("frame_photo2").getChildByName("txt");
        name.setFontStyle("bold");
        name.x = 60;
        name.y = -142
        name.getVirtualRenderer().setAlignment(cc.TEXT_ALIGNMENT_CENTER);
        name.setAnchorPoint(cc.p(0.5, 0.5));
        
        name = item.getChildByName("frame_photo3").getChildByName("txt");
        name.setFontStyle("bold");
        name.x = 60;
        name.y = -142
        name.getVirtualRenderer().setAlignment(cc.TEXT_ALIGNMENT_CENTER);
        name.setAnchorPoint(cc.p(0.5, 0.5));

        var photo = item.getChildByName("frame_photo2").getChildByName("photo");
        photo.setAnchorPoint(cc.p(0.5, 0.5));
        photo.x += 40;
        photo.y -= 40;
        photo = item.getChildByName("frame_photo3").getChildByName("photo");
        photo.setAnchorPoint(cc.p(0.5, 0.5));
        photo.x += 40;
        photo.y -= 40;

        var readTxt = item.getChildByName("txt1");
        readTxt.setFontStyle("bold");
        readTxt.y -= 5;
        var detailTxt = item.getChildByName("txt2");
        detailTxt.setFontStyle("bold");
        detailTxt.y -= 5;

        var display = item.getChildByName("display1");
        display.getChildByName("txt_green").y -= 6;
        display.getChildByName("txt_green").x -= 4;
        display.getChildByName("txt_green").width += 10;
        display.getChildByName("txt_red").y -= 6;
        display.getChildByName("txt_red").x -= 4;
        display.getChildByName("txt_red").width += 10;
        display.getChildByName("txt_green").setFontStyle("bold");
        display.getChildByName("txt_red").setFontStyle("bold");
        display = item.getChildByName("display2");
        display.getChildByName("num1").y -= 6;
        display.getChildByName("num1").x += 0;
        display.getChildByName("num1").width += 10;
        display.getChildByName("num1").setFontStyle("bold");
        display.getChildByName("num2").y -= 6;
        display.getChildByName("num2").x += 0;
        display.getChildByName("num2").width += 10;
        display.getChildByName("num2").setFontStyle("bold");
        display.getChildByName("num3").y -= 6;
        display.getChildByName("num3").x += 0;
        display.getChildByName("num3").width += 10;
        display.getChildByName("num3").setFontStyle("bold");
        display.getChildByName("num4").y -= 6;
        display.getChildByName("num4").x += 0;
        display.getChildByName("num4").width += 10;
        display.getChildByName("num4").setFontStyle("bold");


        scrollView.refreshItemContent(item);

        quickBuildUIBUtton(item.getChildByName("txt2"), (evt) => {
            self.showDetail(evt);
        })

        self.addItemIdx += 1;
    }else{
        cc.director.getScheduler().unscheduleScriptEntry(self.schedulerId);
    }
}

FriendPvpActivityStandingPanel.prototype.setScoreTicketPositionAndAnim = function (scorePos, showScoreAnim, ticketPos, showTicketAnim) {
    var self = this;
    self.scoreTextPos = scorePos;
    self.mainPanelScoreTxtShowAnim = showScoreAnim;
    self.ticketPos = ticketPos;
    self.mainPanelTicketShowAnim = showTicketAnim;
}

FriendPvpActivityStandingPanel.prototype.showRewards = function (data) {
    var self = this;
    var rewards = new Array();
    for(var i = 1; i < data.length; i++){
        var has = false;
        for(var j = 0; j < rewards.length; j++){
            cc.log(data[i].itemId, data[i].num)
            if (data[i].itemId == rewards[j].itemId){
                has = true;
                rewards[j].num += data[i].num;
                break;
            }
        }
        if (!has){
            if (data[i].itemId == 33){
                // 积分
                rewards.push({itemId:data[i].itemId, num:data[i].num, pos:self.scoreTextPos, anim:self.mainPanelScoreTxtShowAnim});
            }else{
                // 门票
                rewards.push({itemId:data[i].itemId, num:data[i].num, pos:self.ticketPos, anim:self.mainPanelTicketShowAnim});
            }
        }
    }
    
    var GetRewardsPanel = require("clover/panel/GetRewardsPanel");
    GetRewardsPanel.show(ContinueCheckName.kFriendPvp, rewards, true, null, true);
}

FriendPvpActivityStandingPanel.prototype.refreshItemContent = function (item) {
    var self = this
    var idx = item.idx;
    var data = self.reportList.list[idx];
    if (data){
        var display = null;
        var score = 0;
        var ticket = 0;
        var isGain = data.isGain;
        var dTime = Localhost.timeInSec() - Math.floor(data.timestamp/1000);
        for (var i = 1; i < data.rewards.length; i++){
            if (data.rewards[i].itemId == 33){
                score = data.rewards[i].num;
            }
            if (data.rewards[i].itemId == 34 || data.rewards[i].itemId == 10100){
                ticket = data.rewards[i].num;
            }
        }
        if (ticket > 0){
            // 没有获得门票
            display = item.getChildByName("display2"); 
            item.getChildByName("display1").setVisible(false);
            item.getChildByName("display2").setVisible(true);
        }else{
            // 有返还门票的
            display = item.getChildByName("display1"); 
            item.getChildByName("display1").setVisible(true);
            item.getChildByName("display2").setVisible(false);
        }
        if (data.result == 1 || data.result == 3 || data.result == 4 || data.result == 6){
            // 胜利
            item.getChildByName("frame_blue").setVisible(!isGain);
            item.getChildByName("frame_gray").setVisible(isGain);
            item.getChildByName("txt1").setVisible(isGain);
            if (data.result == 4 || data.result == 6){
                // 超时的没有战报
                item.getChildByName("txt2").setVisible(false);
            }else{
                item.getChildByName("txt2").setVisible(true);
            }
            if (data.result == 1){
                item.getChildByName("icon1").setVisible(true);
                item.getChildByName("icon2").setVisible(false);
                item.getChildByName("icon3").setVisible(false);
                item.getChildByName("icon4").setVisible(false);
                item.getChildByName("icon5").setVisible(false);
            }else if (data.result == 3){
                item.getChildByName("icon1").setVisible(false);
                item.getChildByName("icon2").setVisible(false);
                item.getChildByName("icon3").setVisible(false);
                item.getChildByName("icon4").setVisible(false);
                item.getChildByName("icon5").setVisible(true);
            }else if (data.result == 4 || data.result == 6){
                item.getChildByName("icon1").setVisible(false);
                item.getChildByName("icon2").setVisible(false);
                item.getChildByName("icon3").setVisible(true);
                item.getChildByName("icon4").setVisible(false);
                item.getChildByName("icon5").setVisible(false);
            }
            if (ticket > 0){
                display.getChildByName("num1").setVisible(true);
                display.getChildByName("num2").setVisible(false);
                display.getChildByName("num1").setString("+" + score);
                display.getChildByName("num3").setVisible(true);
                display.getChildByName("num4").setVisible(false);
                display.getChildByName("num3").setString("+" + ticket);
            }else{
                display.getChildByName("txt_red").setVisible(true);
                display.getChildByName("txt_green").setVisible(false);
                display.getChildByName("txt_red").setString("+" + score);
            }
        }else{
            // 失败
            item.getChildByName("frame_blue").setVisible(!isGain);
            item.getChildByName("frame_gray").setVisible(isGain);
            item.getChildByName("txt1").setVisible(isGain);
            // 超时的没有战报
            item.getChildByName("txt2").setVisible(data.result != 5);
            if (data.result == 2){
                item.getChildByName("icon1").setVisible(false);
                item.getChildByName("icon2").setVisible(true);
                item.getChildByName("icon3").setVisible(false);
                item.getChildByName("icon4").setVisible(false);
                item.getChildByName("icon5").setVisible(false);
            }else if(data.result == 5){
                item.getChildByName("icon1").setVisible(false);
                item.getChildByName("icon2").setVisible(false);
                item.getChildByName("icon3").setVisible(false);
                item.getChildByName("icon4").setVisible(true);
                item.getChildByName("icon5").setVisible(false);
            }
            if (ticket > 0){
                display.getChildByName("num1").setVisible(true);
                display.getChildByName("num2").setVisible(false);
                display.getChildByName("num1").setString("+" + score);
                display.getChildByName("num3").setVisible(true);
                display.getChildByName("num4").setVisible(false);
                display.getChildByName("num3").setString("+" + ticket);
            }else{
                display.getChildByName("txt_red").setVisible(true);
                display.getChildByName("txt_green").setVisible(false);
                display.getChildByName("txt_red").setString("+" + score);
            }
        }
        item.setVisible(true);

        

        var name = item.getChildByName("frame_photo2").getChildByName("txt");
        if (name){
            name.removeFromParent(true);
        }
        name = cc.LabelTTF.create("", null, 20);
        item.getChildByName("frame_photo2").addChild(name);
        name.setAnchorPoint(cc.p(0.5, 0.5));
        name.setPosition(60, -142);
        name.setName("txt");
        name.setFontFillColor(cc.c3b(0, 153, 204));
        name._setFontStyle("bold");
        name.setAlignment(cc.TEXT_ALIGNMENT_CENTER);
        UIUtils.fixTextWidth(name, UserManager.getInstance().profile.name, 150);
        
        name = item.getChildByName("frame_photo3").getChildByName("txt");
        if (name){
            name.removeFromParent(true);
        }
        name = cc.LabelTTF.create("", null, 20);
        item.getChildByName("frame_photo3").addChild(name);
        name.setAnchorPoint(cc.p(0.5, 0.5));
        name.setPosition(60, -142);
        name.setName("txt");
        name.setFontFillColor(cc.c3b(211, 66, 58));
        name._setFontStyle("bold");
        name.setAlignment(cc.TEXT_ALIGNMENT_CENTER);
        UIUtils.fixTextWidth(name, HeDisplayUtil.urlDecode(data.targetName), 150);

        // var name = item.getChildByName("frame_photo2").getChildByName("txt");
        // UIUtils.fixTextWidth(name, UserManager.getInstance().profile.name, 150);

        // name = item.getChildByName("frame_photo3").getChildByName("txt");
        // UIUtils.fixTextWidth(name, HeDisplayUtil.urlDecode(data.targetName), 150);

        var photo = item.getChildByName("frame_photo2").getChildByName("photo");
        HeadImageLoader.loadImage(photo, UserManager.getInstance().profile.headUrl);
        photo = item.getChildByName("frame_photo3").getChildByName("photo");
        HeadImageLoader.loadImage(photo, data.targetAvatar);

        var timeLabel = item.getChildByName("time");
        var day = Math.floor(dTime/3600/24);
        var hour = Math.floor(dTime/3600);
        var minutes = Math.floor(dTime/60);
        if (day > 0){
            timeLabel.setString(day + getText("pvp.battlereport.day"));
        }else if (hour > 0){
            timeLabel.setString(hour + getText("pvp.battlereport.hour"));
        }else if (minutes > 0){
            timeLabel.setString(minutes + getText("pvp.battlereport.minute"));
        }else{
            timeLabel.setString(dTime + getText("pvp.battlereport.second"));
        }
    }else{
        item.setVisible(false);
    }
}

FriendPvpActivityStandingPanel.prototype.showDetail = function (evt) {
    var self = this;
    if (self.isBusy){
        return;
    }
    self.isBusy = true;
    var idx = evt.target.getParent().idx;
    var data = self.reportList.list[idx];
    if (!data.resultInfo || !data.resultInfoTarget){
        Toast.make("没有详情数据");
        self.isBusy = false;
        return;
    }

    var selfTargetFinish = data.resultInfo.collect;
    var targetTotal = data.resultInfo.collectMax;
    var selfScore = data.resultInfo.levelScore;
    var selfTime = data.resultInfo.costTime;
    var selfResult = data.result;
    var enemyTargetFinish = data.resultInfoTarget.collect;
    var enemyScore = data.resultInfoTarget.levelScore;
    var enemyTime = data.resultInfoTarget.costTime;
    var enemyAvatar = data.targetAvatar;
    var enemyResult = 1;
    if (selfResult == 1){
        enemyResult = 2;
    }else if(selfResult == 2){
        enemyResult = 1;
    }else{
        enemyResult = selfResult;
    }
    var gameResult = {
        self:{
            targetFinish:selfTargetFinish, targetTotal:targetTotal, score:selfScore, time:selfTime, result:selfResult
        },
        enemy:{
            targetFinish:enemyTargetFinish, targetTotal:targetTotal, score:enemyScore, time:enemyTime, result:enemyResult, avatar:enemyAvatar
        }
    }
    cc.log(gameResult);

    function resOnSuccess() {
        self.isBusy = false;
        var pvpActivityResultPanel = require("activity/PvpActivity/FriendPvpActivityResultPanel");
        self.resultPanel = pvpActivityResultPanel.show(null, gameResult, true);
    }
    function resOnFail() {
        self.isBusy = false;
        Toast.make(getText("error.tip.timeout"))
    }
    preloadWithLoading(["packed/PvpSettlement2Res.pack"], resOnSuccess, resOnFail, resOnFail);
}

FriendPvpActivityStandingPanel.prototype.popup = function (callback) {
    var self = this;
    var targetScale = self.getScale()*1.1;
    self.setScale(0);
    var time = 7 / 30;
    PopoutManager.getInstance().addWithBgFadeIn(self, true, false, callback);
    var vSize = cc.Director.getInstance().getVisibleSize();
    var dH = display.height-GamePlayConfig_Design_Height;
    var targetPos = cc.pAdd(cc.p(self.getPosition()), cc.p(90, 1000 + dH/2));
    var pos_O = cc.p(vSize.width / 2, vSize.height / 2);
    var startPoint = cc.pMul(cc.pSub(targetPos, pos_O), 0.23);
    self.setScale(0.23);
    self.setPosition(cc.p(pos_O.x + startPoint.x, pos_O.y + startPoint.y));
    self.runAction(cc.Sequence.create(cc.EaseSineOut.create(cc.Spawn.create(cc.ScaleTo.create(time, targetScale), cc.MoveTo.create(time, targetPos)))));
    return self
}

FriendPvpActivityStandingPanel.prototype.onCleanup = function() {
    ResManager.release(["packed/PvpStandingRes.pack"]);
}

module.exports = FriendPvpActivityStandingPanel